// Corrected EditNotifications
// Desktop styling/functionality unchanged
// Small screen: smaller font + properly aligned checkboxes
// Page fits properly on very small screens

import React from "react";
import "./EditNotifications.css";

const EditNotifications = ({
  notifications = {},
  onChange,
  onSubmit,
}) => {
  // Define notification fields with parent-child relationships
  const notificationGroups = [
    {
      label: "Cases Created",
      field: "casesCreatedByAccount",
      subItems: [
        {
          label: "Cases Created, by the Account",
          field: "casesCreatedByAccount",
        },
        {
          label: "Cases Created, by the Lab",
          field: "casesCreatedByLab",
        },
      ],
    },
    {
      label: "Cases Changed",
      field: "casesChangedByAccount",
      subItems: [
        {
          label: "Account Changed, by the Account",
          field: "accountChangedByAccount",
        },
        {
          label: "Account Changed, by the Lab",
          field: "accountChangedByLab",
        },
      ],
    },
    {
      label: "Pickup Requests",
      field: "pickupRequests",
    },
    {
      label: "Balance Payments",
      field: "balancePayments",
    },
    {
      label: "Invoices",
      field: "invoices",
    },
    {
      label: "Processes",
      field: "processes",
    },
    {
      label: "Accounts",
      field: "accounts",
    },
    {
      label: "Accounts Changed, by the Lab",
      field: "accountsChangedByLab",
    },
  ];

  // Extract webNotifications from props with a fallback
  const { webNotifications = {} } = notifications;

  // Handle checkbox changes
  const handleChange = (field, checked) => {
    const updatedNotifications = {
      ...notifications,
      webNotifications: {
        ...webNotifications,
        [field]: checked,
      },
    };

    onChange(updatedNotifications);
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      webNotifications,
    });
  };

  return (
    <div className="notifications-wrapper">
      <div className="row">
        <div className="col-md-10">
          <h1>Web Notifications</h1>

          <form onSubmit={handleSubmit}>
            <div className="Web Notification notifications-box">
              <h4>Labnext Activity Log</h4>

              <div className="checks notifications-checks">
                {notificationGroups.map((group, index) => (
                  <div key={index}>
                    {/* Parent item */}
                    <div className="notification-parent">
                      <label htmlFor={`notification-${index}`}>
                        <input
                          id={`notification-${index}`}
                          type="checkbox"
                          name={group.label}
                          checked={
                            webNotifications[group.field] || false
                          }
                          onChange={(e) =>
                            handleChange(
                              group.field,
                              e.target.checked
                            )
                          }
                        />

                        <span>{group.label}</span>
                      </label>
                    </div>

                    <br />

                    {/* Sub-items */}
                    {group.subItems &&
                      group.subItems.length > 0 && (
                        <div className="notification-subitems">
                          {group.subItems.map(
                            (subItem, subIndex) => (
                              <div
                                key={subIndex}
                                className="notification-subitem"
                              >
                                <label
                                  htmlFor={`notification-${index}-${subIndex}`}
                                >
                                  <input
                                    id={`notification-${index}-${subIndex}`}
                                    type="checkbox"
                                    name={subItem.label}
                                    checked={
                                      webNotifications[
                                        subItem.field
                                      ] || false
                                    }
                                    onChange={(e) =>
                                      handleChange(
                                        subItem.field,
                                        e.target.checked
                                      )
                                    }
                                  />

                                  <span>{subItem.label}</span>
                                </label>

                                <br />
                              </div>
                            )
                          )}
                        </div>
                      )}

                    <br />
                  </div>
                ))}
              </div>
            </div>

            {/* Save Button */}
            <div className="notifications-save">
              <button type="submit">
                Save Notifications
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditNotifications;